import { render, staticRenderFns } from "./OtimizadorStep.vue?vue&type=template&id=3cfcf597&scoped=true"
import script from "./OtimizadorStep.vue?vue&type=script&lang=js"
export * from "./OtimizadorStep.vue?vue&type=script&lang=js"
import style0 from "./OtimizadorStep.vue?vue&type=style&index=0&id=3cfcf597&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfcf597",
  null
  
)

export default component.exports